import { FontAwesomeIcon } from "@fortawesome/react-fontawesome"
import { faClose } from '@fortawesome/free-solid-svg-icons';

const AbstractModal = ({children, open, setOpen})=>{


    return open ? (

        <div className="fixed inset-0 z-50 flex items-center justify-center p-4 overflow-auto bg-black bg-opacity-50">
            <div className="my-10">
                <div onClick={()=>setOpen(false)} className="absolute w-10 p-2 text-center bg-gray-700 rounded-full cursor-pointer hover:bg-gray-800 top-10">
                    <FontAwesomeIcon icon={faClose} color="gray"/>
                </div>
                {children}
            </div>
        </div>

    ) : null
}


export default AbstractModal